import { createComponent } from '../utils';
import { useSubheading } from './useSubheading';
export default createComponent({
  useHook: useSubheading,
  name: 'Subheading'
});